require('../modules/esnext.math.clamp');
require('../modules/esnext.math.deg-per-rad');
require('../modules/esnext.math.degrees');
require('../modules/esnext.math.fscale');
require('../modules/esnext.math.rad-per-deg');
require('../modules/esnext.math.radians');
require('../modules/esnext.math.scale');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/math-extensions.js
// module id = P/OS
// module chunks = 2